import type { ReactNode } from 'react';

interface PageHeroProps {
  index?: string;
  eyebrow?: string;
  title: string;
  description?: string;
  /** Optional full-color background photo; falls back to the deep-green field. */
  image?: string;
  children?: ReactNode;
}

export default function PageHero({ index, eyebrow, title, description, image, children }: PageHeroProps) {
  return (
    <section className={`relative overflow-hidden text-white ${image ? 'bg-primary-deep' : 'bg-primary-deep'}`}>
      {image && (
        <>
          <div
            className="absolute inset-0 bg-cover bg-[position:70%_50%]"
            style={{ backgroundImage: `url(${image})` }}
            aria-hidden="true"
          />
          <div
            className="absolute inset-0 bg-gradient-to-r from-primary-deep via-primary-deep/55 to-transparent"
            aria-hidden="true"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-deep/60 via-transparent" aria-hidden="true" />
        </>
      )}
      <div className="container-page relative py-16 sm:py-24">
        {children && <div className="mb-8">{children}</div>}
        {(eyebrow || index) && (
          <div className="kicker text-secondary-light">
            {index && <span className="text-sm tracking-normal text-secondary-light">{index}</span>}
            {eyebrow && <span>{eyebrow}</span>}
          </div>
        )}
        <h1 className="mt-5 max-w-4xl text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {description && (
          <p className="mt-6 max-w-2xl text-lg leading-8 text-white/80">{description}</p>
        )}
      </div>
    </section>
  );
}
